<template>
  <MainMenuView :title="title" @close="$emit('close')" containerClass="container-fluid">
    <Codes :title="title" :typesToShow="typesToShow" :byConditions="byConditions" :settingsToShow="settingsToShow" />
  </MainMenuView>
</template>
<script>
import { STORE_DISCOUNT } from '../../../../constants';
export default {
  name: 'Redemptions',
  components: {
    Codes: () => import('../Codes'),
    MainMenuView: () => import('../MainMenuView.vue')
  },
  data() {
    return {
      title: 'Redemption Codes',
      typesToShow: [STORE_DISCOUNT.TYPES.REDEMPTIONS],
      byConditions: [],
      settingsToShow: Object.values(
        Object.fromEntries(
          Object.entries(STORE_DISCOUNT.SETTINGS).filter(([key, value]) =>
            [
              STORE_DISCOUNT.SETTINGS.NAME,
              STORE_DISCOUNT.SETTINGS.CODE,
              STORE_DISCOUNT.SETTINGS.DURATION,
              STORE_DISCOUNT.SETTINGS.MULTIPLE_CUSTOMER_USE,
              STORE_DISCOUNT.SETTINGS.ORDERS_AMOUNT,
              STORE_DISCOUNT.SETTINGS.MULTIPLE_USE
            ].includes(value)
          )
        )
      )
    };
  }
};
</script>
